import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {View, Alert, ScrollView, TouchableOpacity} from 'react-native';
import FeatherIcon from 'react-native-vector-icons/Feather';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import FastImage from '../../Utils/FastImage';

///////////////   utils

import {pauseHunt} from 'src/Utils/huntFunctions';

import {PrimaryButton, FooterOverlay} from 'src/Modules/CommonView';

///////////////   components

import Photos from 'src/Modules/CommonGame/Photos';

import {BodyText} from 'src/Modules/CommonView';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {usePercentageComplete} from '../../Hooks/gameHooks';

const Dashboard = () => {
  const {width, height} = useWindowDimensionsSafe();

  const userId = useSelector((state) => state.user?.userId);
  const tickets = useSelector((state) => state.user?.info?.tickets);
  const groupInfo = useSelector((state) => state.groupInfo);
  const playerChallengePhotos =
    useSelector((state) => state.game?.playerChallengePhotos) || [];
  const treasureChallengePhotos =
    useSelector((state) => state.game?.treasureChallengePhotos) || [];
  const anyTimePhotos = useSelector((state) => state.game?.anyTimePhotos) || [];
  const allChallenges =
    useSelector((state) => state.game_v2?.allChallenges) || [];

  const timerFinish = useSelector((state) => state.game_v2?.timerFinish);
  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const [showPhotos, setShowPhotos] = useState(false);

  console.log('PlayerDash Render');

  const {groupId, eventId, classic_hunt} = groupInfo;

  const locationPhotos = Object.values(allChallenges).filter((challenge) => {
    return (
      (challenge.type === 'photo' || challenge.type === 'video') &&
      challenge.photoUrl
    );
  });

  const photoObjects = [
    ...playerChallengePhotos,
    ...treasureChallengePhotos,
    ...locationPhotos,
    ...anyTimePhotos,
  ];
  groupInfo?.groupPhoto &&
    photoObjects.unshift({
      photoUrl: groupInfo?.groupPhoto,
      challenge: 'Have one player take an epic team photo to start your hunt.',
    });

  const percentageComplete = usePercentageComplete();

  const corporateBrandingUrl = useSelector(
    (state) => state.game_v2?.corporateBrandingUrl,
  );

  if (showPhotos) {
    return (
      <Photos
        width={width}
        height={height}
        photoData={photoObjects}
        handleBack={() => setShowPhotos(false)}
        flag
      />
    );
  }

  if (!showPhotos) {
    const ticketCount = tickets?.[groupInfo?.theme] || 0;

    return (
      <View
        style={{
          flex: 1,
          backgroundColor: global?.color?.white,
          position: 'relative',
        }}>
        <ScrollView style={{flex: 1}}>
          {!corporateBrandingUrl && (
            <View
              style={{
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <BodyText
                text={'Dashboard'}
                textStyle={{
                  fontWeight: '700',
                  fontSize: 18,
                  lineHeight: 20,
                }}
              />
            </View>
          )}
          {!!corporateBrandingUrl && (
            <View
              style={{
                height: 80,
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: 80,
              }}>
              <FastImage
                style={{height: 80, width}}
                source={{uri: corporateBrandingUrl}}
                resizeMode={FastImage?.resizeMode?.contain}
              />
            </View>
          )}
          <View
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              width: width - 10,
              margin: 5,
            }}>
            {!!groupInfo?.eventId && (
              <DashTile
                icon={'users'}
                text={`Event Dashboard`}
                iconColor={global?.color?.purple}
                handlePress={() => navigationRef.navigate('EventDashboard')}
              />
            )}
            {!timerFinish && (
              <DashTile
                icon={'plus-circle'}
                text={'Add Players'}
                iconColor={global?.color?.orange}
                handlePress={() => {
                  navigationRef.navigate('AddPlayerModal', {
                    isEvent: eventId ? true : false,
                    joinCode: groupInfo?.groupId,
                    prepaidJoinCode: userId,
                    tickets: ticketCount,
                    eventId: groupInfo?.eventId,
                    groupInfo,
                    huntStarted: true,
                  });
                }}
              />
            )}
            {!timerFinish && (
              <DashTile
                icon={'pause-circle'}
                text={'Pause Hunt'}
                iconColor={global?.color?.teal}
                handlePress={() => {
                  pauseHunt(groupId);
                }}
              />
            )}
            {!timerFinish && (
              <DashTile
                icon={'minus-circle'}
                text={'Remove Players'}
                iconColor={'red'}
                handlePress={() => {
                  navigationRef.navigate('GameLobbyPlayersModal');
                }}
              />
            )}
            <DashTile
              icon={'aperture'}
              iconColor={global?.color?.blue}
              text={'All Photos'}
              handlePress={() => {
                photoObjects?.length > 0
                  ? setShowPhotos(true)
                  : Alert.alert(`You haven't taken any photos yet!`);
              }}
            />
            <DashTile
              icon={'life-buoy'}
              iconColor={global?.color?.red}
              text={'Help'}
              handlePress={() => {
                navigationRef.navigate('HelpModal');
              }}
            />
            {!playTestState && (
              <DashTile
                icon={'help-circle'}
                text={`FAQ`}
                iconColor={global?.color?.magenta}
                handlePress={() => {
                  navigationRef.navigate('FAQ');
                }}
              />
            )}
            {!playTestState && (
              <DashTile
                icon={'help-circle'}
                text={`Call Support`}
                iconColor={global?.color?.magenta}
                handlePress={() => {
                  navigationRef.navigate('SupportModal');
                }}
              />
            )}
            {!!groupInfo?.eventId && (
              <DashTile
                icon={'call'}
                text={`Leaderboard`}
                iconColor={global?.color?.purple}
                handlePress={() => navigationRef.navigate('EventDashboard')}
              />
            )}
          </View>
        </ScrollView>
        {!classic_hunt && (
          <View>
            <BodyText
              text={`${percentageComplete}% Complete`}
              textStyle={{
                marginVertical: 20,
                fontSize: 18,
                lineHeight: 20,
                textAlign: 'center',
              }}
            />
          </View>
        )}
        <FooterOverlay>
          <PrimaryButton
            background={global?.color?.gray3}
            text={'Back'}
            handlePress={() => {
              navigationRef.goBack('PlayerDash');
            }}
          />
        </FooterOverlay>
      </View>
    );
  }
};

const DashTile = ({icon, iconColor, text, handlePress}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      onPress={handlePress}
      disabled={!handlePress}
      style={{
        width: (width - 30) / 2,
        margin: 5,
        backgroundColor: global?.color?.white1,
        paddingHorizontal: 15,
        paddingBottom: 20,
        paddingTop: 10,
        borderRadius: 10,
      }}>
      <FeatherIcon
        name={icon}
        size={22}
        color={iconColor || global?.color?.orange}
      />
      <BodyText
        text={text}
        textStyle={{marginLeft: 0, marginTop: 10, fontWeight: '700'}}
      />
    </TouchableOpacity>
  );
};

export default Dashboard;
